import mainTemplate from './views/base.tpl.html';
import listTemplate from './views/list.tpl.html';
import VoucherTemplatesListController from './controllers/list-controller';
import TemplatesDetailsController from "./controllers/details-controller";
import detailsTemplate from "./views/details.tpl.html";

angular
    .module('festzelt-os.vouchers.templates')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.vouchers.templates', {
            abstract: true,
            url: '/templates',
            templateUrl: mainTemplate,
            params: {
                back: 'app.vouchers.templates.index',
                backParams: ['$stateParams', ($stateParams) => {
                    return {
                        store: $stateParams.store,
                    }
                }],
            },
            data: {
                showBackBtn: true,
                pageTitle: 'Voucher Templates'
            }
        })
        .state('app.vouchers.templates.index', {
            url: '',
            sticky: true,
            data: {
                showBackBtn: false,
                view: 'list',
                rights: "vouchers::templates-list"
            },
            views: {
                list: {
                    templateUrl: listTemplate,
                    controller: VoucherTemplatesListController,
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.vouchers.templates.details', {
            url: '/{id}',
            params: {
                id: {
                    type: 'int'
                }
            },
            data: {
                bodyClass: 'wide',
                view: 'details',
                rights: 'templates::view'
            },
            views: {
                details: {
                    controller: TemplatesDetailsController,
                    controllerAs: 'vm',
                    templateUrl: detailsTemplate
                }
            }
        })
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/routes.js